import { IHttpApi } from '@cian/http-api';
import {
  fetchFilterPikNewbuildings,
  IFilterPikNewbuildingsRequest,
  IFilterPikNewbuildingsResponse,
  IFilterPikNewbuildingsResponse200,
  IFilterPikNewbuildingsResponse400,
} from '../../repositories/monolith-python/v1/filter-pik-newbuildings';
import { assertNotFoundError } from './assert/assertNotFoundError';

export const getFilterPikNewbuildings = async ({
  httpApi,
  parameters,
}: {
  httpApi: IHttpApi;
  parameters: IFilterPikNewbuildingsRequest;
}): Promise<IFilterPikNewbuildingsResponse> => {
  const response = await fetchFilterPikNewbuildings<
    IFilterPikNewbuildingsResponse200,
    IFilterPikNewbuildingsResponse400
  >({ httpApi, parameters });

  assertNotFoundError(response);

  return response.response as IFilterPikNewbuildingsResponse;
};
